<template>
    <div class="scroll">
        <div class="scroll-ani"></div>
    </div>
</template>

<script>

export default{
    props : {
    },
    components: {
    },
    data: () => {
        return {
        }
    },
	created() {
	},
	// mounted() {
	// 	this.init();
	// },
	// methods : {
	// 	init : function() {
    //         setTimeout(() => {
    //             AOS.init({
    //                 once: false,
    //                 offset: 240,
    //                 duration: 500,
    //                 throttleDelay : 100,
    //                 easing : 'ease-in-out',
    //                 anchorPlacement : 'top-center',
    //             });
    //         }, 100);
	// 	}
	// },
}
</script>

<style scoped>
.scroll{
    position: absolute;
    width: 2px;
    height: 80px;
    background-color: rgba(255, 255, 255, 0.3);
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
}
.scroll-ani{
    position: relative;
    width: 100%;
    height: 100%;
}
.scroll-ani::after{
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 50px;
    background-color: #fff;
    top: 0;
    left: 0;
    animation: scr 1.5s linear infinite;
}

@keyframes scr{
    0%{
        top: 0;
        opacity: 1;
    }
    20%{
        opacity: 1;
    }
    100%{
        top: 30px;
        opacity: 0;
    }
}
</style>